import { AdminSettingsResponse } from '../../../types';
import { useGetAdminSettings } from '../../../../queries';

export const GROUP_NAME_PWD_RULES = 'password-rules';
export const GROUP_NAME_SSO = 'single-sign-on';
export const GROUP_NAME_CASE_SENS = 'case-sensitive-login';
export const GROUP_NAME_SYNC = 'account-synchronisation-email';

export const usePwdUserSettingsMultipleEndpoint = () => {
  const { isFetching: isFetchingNameAndPwd, data: nameAndPwdSettings = [] } =
    useGetAdminSettings<AdminSettingsResponse>(GROUP_NAME_PWD_RULES);

  const { isFetching: isFetchingSSO, data: ssoSettings = [] } =
    useGetAdminSettings<AdminSettingsResponse>(GROUP_NAME_SSO);

  const { isFetching: isFetchingNameCase, data: nameCase = [] } =
    useGetAdminSettings<AdminSettingsResponse>(GROUP_NAME_CASE_SENS);

  const { isFetching: isFetchingNameSync, data: nameSync = [] } =
    useGetAdminSettings<AdminSettingsResponse>(GROUP_NAME_SYNC);

  const userAndPwdSettingsAsync = {
    nameAndPwdSettings: nameAndPwdSettings,
    ssoSettings: ssoSettings,
    nameCase: nameCase,
    nameSync: nameSync
  };

  return {
    userAndPwdSettings: userAndPwdSettingsAsync,
    isFetching:
      isFetchingNameAndPwd ||
      isFetchingSSO ||
      isFetchingNameCase ||
      isFetchingNameSync
  };
};
